<template>
	<header>
		<div
			:class="(navBarActive)?'mobile-line mobile-line--hide':'mobile-line'"
			@click.stop.prevent="navBarOpen"
			ref="mobileNavLink"
		>
			<button class="vs-navbar--btn-responsive">
				<span class="btn-responsive-line line--1"></span>
				<span class="btn-responsive-line line--2"></span>
				<span class="btn-responsive-line line--3"></span>
			</button>
		</div>
		<div
			:class="(navBarActive)?'mobile-line mobile-line-clear':'mobile-line mobile-line-clear mobile-line--hide'"
			@click.stop.prevent="navBarClose"
		>
			<i class="icons8-multiply-40"></i>
		</div>
		<div :class="(navBarActive)?'header-nav header-nav--active':'header-nav'" ref="headerNav">
			<ul class="header-ul">
				<li class="header-li" v-show="showForecast">
					<router-link
						:to="{name:'forecast'}"
						class="nav-link vs-button nav-link"
						:class="$route.name==='forecast'?'active':''"
						tag="a"
					>
						<p>Forecast</p>
					</router-link>
				</li>
				<li class="header-li report-subheader-parent" @click.stop="reportOptions">
					<a
						href="javascript:void(0)"
						class="nav-link vs-button nav-link"
						:class="$route.meta.parent==='reports'?'active':''"
					>
						<p>
							Reports
							<i class="list-down-arrow arrow-down"></i>
						</p>
					</a>

					<div class="report-subheader-nav" ref="reportnav">
						<ul>
							<li v-show="showReport">
								<router-link :to="{name:'bench-overview'}">Forecast</router-link>
							</li>
							<li>
								<router-link :to="{name:'qtimeReports'}">QTime</router-link>
							</li>
							<li>
								<router-link :to="{name:'employee-overview'}">Employee Overview</router-link>
							</li>
							<!-- <li v-if="isManager && isManager.deliveryManager !== null && isManager.deliveryManager && ShowOverviewMenuOption">
								<router-link :to="{name:'delivery-manager-employee'}">Delivery Manager Overview</router-link>
							</li>
							<li v-if="isManager && isManager.directManager !== null && isManager.directManager && ShowOverviewMenuOption">
								<router-link :to="{name:'direct-manager-overview'}">Direct Manager Overview</router-link>
							</li>
							<li v-if="isManager && isManager.deliveryManager !== null && isManager.deliveryManager && ShowOverviewMenuOption">
								<router-link :to="{name:'release-overview'}">Release Overview</router-link>
							</li>
							<li v-if="isManager && isManager.directManager !== null && isManager.directManager && ShowOverviewMenuOption">
								<router-link :to="{name:'release-overview-manager'}">Release Overview Direct Manager</router-link>
							</li> -->
						</ul>
					</div>
				</li>
				<!--adding qtime drop down option-->
				<li class="header-li qtime-subheader-parent" @click.stop="qtimeOptions">
					<a
						href="javascript:void(0)"
						class="nav-link vs-button nav-link"
						:class="$route.name==='qtime' || $route.name==='leaveRequest' || $route.name==='sicknessRequest'?'active':''"
					>
						<p>
							QTime
							<i class="list-down-arrow arrow-down"></i>
						</p>
					</a>

					<div class="qtime-subheader-nav" ref="qtimenav">
						<ul>
							<li>
								<router-link :to="{name:'qtime'}">Time Registration</router-link>
							</li>
							<li>
								<router-link :to="{name:'leaveRequest'}">Vacation Request</router-link>
							</li>
							<li>
								<router-link :to="{name:'sicknessRequest'}">Sickness Report</router-link>
							</li>
							<li>
								<!-- <a href="../../assets/pdf/Hilfe_Dokumentation.pdf" target="_blank">Help</a>-->
								<div class="dropdown">
								<a class="dropbtn"  target="_blank">Help</a>
								<div class="dropdown-content">
									<div v-for="pdfpath in pdfpathList" v-bind:key="pdfpath.index" >
									<a  @click="download(pdfpath.pdfPath)">{{pdfpath.pdfPath}}</a>
									</div>
								</div>
								</div>
							</li>
						</ul>
					</div>
				</li>

				<!-- <li class="header-li"> 
					<router-link
						:key="$route.path"
						:to="{name:'qtime'}"
						class="nav-link vs-button nav-link"
						tag="a"
						:class="$route.name==='qtime'?'active':''"
					>
						<p>Time Registration</p>
					</router-link>
				</li>
					<li class="header-li">
					<router-link
						:key="$route.path"
						:to="{name:'leaveRequest'}"
						class="nav-link vs-button nav-link"
						tag="a"
						:class="$route.name==='leaveRequest'?'active':''"
					>
						<p>Vacation Request</p>
					</router-link>
				</li>
				<li class="header-li">
					<router-link
						:key="$route.path"
						:to="{name:'sicknessRequest'}"
						class="nav-link vs-button nav-link"
						tag="a"
						:class="$route.name==='sicknessRequest'?'active':''"
					>
						<p>Sickness Request</p>
					</router-link>
				</li> -->
			</ul>
		</div>
		<div class="header-info">
			<div class="header-info-links">
				<!--                <div>-->
				<!--                    <button class="header-button vs-con-dropdown header-button vs-button vs-button-filled">-->
				<!--						<span class="vs-button-text vs-button&#45;&#45;text">-->
				<!--							Add time registration-->
				<!--							<i class="add-more"></i>-->
				<!--						</span>-->
				<!--                    </button>-->
				<!--                </div>-->

				<div class="account" ref="accountBlock">
					<button
						type="button"
						@click.stop.prevent="openProfile"
						class="vs-con-dropdown parent-dropdown"
					>
						<a class="a-icon profile-name" href.prevent>{{userName}}</a>
						<div class="portrait" ref="accountDom">
							<!--                            <img :src="userImage" alt/>-->
							<!-- <img src="../../../public/assets/images/portraits/rasmus-henriskon.png" alt /> -->
							<img src="../../../public/assets/images/portraits/avatar.png" alt />
						</div>
					</button>
					<div class="dropdown-menu-nav" ref="dropdownMenuNav">
						<ul>
							<li>
								<a class="log-out-url" href="#" @click="logout">Logout</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</header>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      navActive: "#5899bf",
      navBarActive: false,
      //canAccessQForecastForecasting: true,
      canAccessQForecastReporting: true
    };
  },
  computed: {
    userImage: function() {
      return this.$store.state.auth.user_image;
    },

	isManager: function(){
			return this.$store.state.qtimeReports.isManager;
		},
    /**
     * Get current Podio user
     */
    podioUser: function() {
      return this.$store.state.auth.podio_user;
    },
    /**
     * Get user full name from the podio user object
     * @returns {string}
     */
	ShowOverviewMenuOption: function() {
      return this.podioUser.canAccessOverviewMenus;
    },
    userName: function() {
      if (this.podioUser.firstName && this.podioUser.lastName) {
        return `${this.podioUser.firstName} ${this.podioUser.lastName}`;
      } else if (this.podioUser.firstName) {
        return this.podioUser.firstName;
      } else {
        return "";
      }
    },
    showForecast: function() {
    //   if (this.podioUser.canAccessQForecastForecasting === false) {
    //     this.canAccessQForecastForecasting = false;
    //   }
      return this.podioUser ? this.podioUser.canAccessQForecastForecasting : null;
    },
    showReport: function() {
      if (this.podioUser.canAccessQForecastReporting === false) {
        this.canAccessQForecastReporting = false;
      }
      return this.podioUser.canAccessQForecastReporting || false;
    },
	pdfpathList:function(){
		return this.$store.state.auth.pdfName;
	}
  },
  methods: {
    //  opens navbar in mobile
    navBarOpen: function() {
      this.navBarActive = true;
    },
    navBarClose: function() {
      this.navBarActive = false;
    },
    openProfile: function() {
      this.$refs.dropdownMenuNav.classList.toggle("dropdown-open");
    },
    /**
     * Logout request
     */
    logout: function() {
      this.$store.dispatch("logout").then(() => {
		// redirect to the login page on logout
		//console.log(this.$route);
        this.$router.push({ name: "login", query: { redirect: this.$route.path } });
      });
    },

    reportOptions: function() {
      this.$refs.reportnav.classList.toggle("open-report-nav");
      setTimeout(function(){
      if(document.querySelector('.report-header-options') != undefined && document.querySelector('.report-header-options') != null){
        document.querySelector('.report-header-options').classList.remove('r-open');
      }
      }, 100);
    },
	qtimeOptions: function() {
      this.$refs.qtimenav.classList.toggle("open-qtime-nav");
      setTimeout(function(){
      if(document.querySelector('.report-header-options') != undefined && document.querySelector('.report-header-options') != null){
        document.querySelector('.report-header-options').classList.remove('r-open');
      }
      }, 100);
    },
	download: function(path){
		var url='../../assets/pdf/'+path+'.pdf';
		var urls = [
		url,
		];
		var link = document.createElement('a');
		link.setAttribute('download','');
		link.style.display = 'none';
		document.body.appendChild(link);
		for (var i = 0; i < urls.length; i++) {
			link.setAttribute('href', urls[i]);
			link.click();
		}
		document.body.removeChild(link);
			}
		},
		beforeMount(){
			this.$store.dispatch("ManagerCheck");
		},
  mounted() {
	if (
        this.$route.name === "forecast" &&
        this.showForecast === false
      ) {
        return this.$router.push("qtime");
	}
	
    document.body.addEventListener("click", e => {
      if (e.srcElement !== this.$refs.accountBlock) {
        this.$refs.dropdownMenuNav.classList.remove("dropdown-open");
        this.$refs.reportnav.classList.remove("open-report-nav");
		this.$refs.qtimenav.classList.remove("open-qtime-nav");
      }
      
      if(document.querySelector('.header-nav') != undefined && document.querySelector('.header-nav') != null){
          if(!e.srcElement.closest('.header-ul')){
              document.querySelector('.header-nav').classList.remove('header-nav--active');
          }
      }
    });
    
     document.body.addEventListener('touchstart', (e)=>{
        e.stopPropagation();
               // Click event
               if(!e.srcElement.closest('.header-ul') && !e.srcElement.closest('.mobile-line')){
                  document.querySelector('.header-nav').classList.remove('header-nav--active');
                  this.navBarActive = false;
            }
            })
  },
  watch: {
    showForecast: function() {
      if (
        this.$route.name === "forecast" &&
        this.showForecast === false
      ) {
        return this.$router.push("qtime");
      }
    },
    canAccessQForecastReporting: function() {
      if (
        (this.$route.name === "bench-overview" ||
          this.$route.name === "customer-engagement" ||
          this.$route.name === "customer-turnover" ||
          this.$route.name === "consultant-workload" ||
          this.$route.name === "qcentris-unit-turnover" ||
          this.$route.name === "qcentris-country-turnover") &&
        this.canAccessQForecastReporting === false
      ) {
        return this.$router.push("/qtimeReports/qtime-activity");
      }
    }
  }
};
</script>

<style>
	header {
		position: relative;
		z-index: 999;
	}

	.con-vs-dropdown--menu {
		width: 240px;
	}

	/*dropdown menu style*/
	.dropdown-menu-nav {
		max-height: 0;
		overflow: hidden;
		position: absolute;
		top: 40px;
		left: -30px;
		width: 200px;

		background: #d50032;
		z-index: 9;
		box-shadow: 1px 7px 10px 0px rgba(0, 0, 0, 0.14);
		-moz-box-shadow: 1px 7px 10px 0px rgba(0, 0, 0, 0.14);
		-webkit-box-shadow: 1px 7px 10px 0px rgba(0, 0, 0, 0.14);
	}

	.dropdown-menu-nav.dropdown-open {
		max-height: 4000px;
	}

	.dropdown-menu-nav li {
		padding: 14px 20px;
	}

	.header-li p {
		display: inline;
	}

	.header-li .nav-link p {
		position: relative;
	}

	.header-li .nav-link.active p:after {
		content: "";
		display: inline-block;
		position: absolute;
		bottom: -8px;
		left: 0;
		width: 100%;
		height: 3px;
		background: #000000;
	}

	.report-subheader-parent {
		position: relative;
	}

	.report-subheader-nav {
		position: absolute;
		top: 60px;
		left: 0;
		height: auto;
		max-height: 0;
		width: 238px;
		background: #d50032;
		z-index: 997;
		box-shadow: 1px 7px 10px 0px rgba(0, 0, 0, 0.14);
		-moz-box-shadow: 1px 7px 10px 0px rgba(0, 0, 0, 0.14);
		-webkit-box-shadow: 1px 7px 10px 0px rgba(0, 0, 0, 0.14);
		overflow: hidden;

		border-radius: 0.25rem;
		-webkit-border-radius: 0.25rem;
		-moz-border-radius: 0.25rem;
	}

	@media screen and (max-width: 1200px) {
		.report-subheader-nav.open-report-nav {
			z-index: 9999;
			width: 100%;
		}
	}

	.report-subheader-nav.open-report-nav {
		max-height: 4000px;
		height: auto;
		border: 1px solid rgba(0, 0, 0, 0.15);
	}
	
	.report-subheader-nav li a {
		/* padding: 16px 20px; */
		padding: 8px 20px;
		display: inline-block;
	}

	/* Report header styles for updation */
	.report-subheader-nav.open-report-nav li a {
		font-weight: 700;
		text-decoration: none;
		color: #ffffff;
		font-size: 16px;
		line-height: 24px;
	}

	.report-subheader-nav.open-report-nav {
		/* padding-top: 20px;
		padding-bottom: 20px; */
		padding-top: 10px;
		padding-bottom: 10px;
	}
	/*Qtime tab style */
	.qtime-subheader-parent {
		position: relative;
	}
	.qtime-subheader-nav {
		position: absolute;
		top: 60px;
		left: 0;
		height: auto;
		max-height: 0;
		width: 181px;
		background: #d50032;
		z-index: 997;
		box-shadow: 1px 7px 10px 0px rgba(0, 0, 0, 0.14);
		-moz-box-shadow: 1px 7px 10px 0px rgba(0, 0, 0, 0.14);
		-webkit-box-shadow: 1px 7px 10px 0px rgba(0, 0, 0, 0.14);
		/*overflow: hidden;*/
		opacity: 0;
		visibility: hidden;
		z-index: -1;

		border-radius: 0.25rem;
		-webkit-border-radius: 0.25rem;
		-moz-border-radius: 0.25rem;
	}
	@media screen and (max-width: 1200px) {
		.qtime-subheader-nav.open-qtime-nav {
			z-index: 9999;
			width: 100%;
		}
	}

	.qtime-subheader-nav.open-qtime-nav {
		max-height: 4000px;
		height: auto;
		border: 1px solid rgba(0, 0, 0, 0.15);
		opacity: 1;
		visibility: visible;
		z-index: 1;
	}
   .qtime-subheader-nav li a {
		/* padding: 16px 20px; */
		padding: 8px 20px;
		display: inline-block;
	}
	/* qtime header styles for updation */
	.qtime-subheader-nav.open-qtime-nav li a {
		font-weight: 700;
		text-decoration: none;
		color: #ffffff;
		font-size: 16px;
		line-height: 24px;
	}

	.qtime-subheader-nav.open-qtime-nav {
		/* padding-top: 20px;
		padding-bottom: 20px; */
		padding-top: 10px;
		padding-bottom: 10px;
	}



	/*new style help*/
	.dropbtn {
  padding: 16px;
  font-size: 16px;
  border: none;
}

.dropdown {
  position: relative;
    display: block;
    width: 100%;
}

.dropdown-content {
  display: none;
  position: absolute;
  min-width: 160px;
  z-index: 1;
    min-width: 200px;
    left: 100%;
    top: 0;
	background: #d50032;
	border: 1px solid rgba(0, 0, 0, 0.15);
	-webkit-box-shadow: 1px 7px 10px 0px rgb(0 0 0 / 14%);
	-webkit-border-radius: 0.25rem;
}

.dropdown-content a {
    display: none;
    position: relative;
    min-width: 160px;
    z-index: 1;
  
}


.dropdown:hover .dropdown-content {display: block;}
/*custom new style*/
.qtime-subheader-nav .dropdown a {
    cursor: pointer;
    width: 100%;
}

.qtime-subheader-nav.open-qtime-nav .dropdown-content a {
    font-size: 15px;
}

.qtime-subheader-nav .dropdown:after {
    position: absolute;
    content: "";
    display: inline-block;
    background: url(data:image/png;base64,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)
        no-repeat;
    overflow: hidden;
    text-indent: -9999px;
    text-align: left;
    background-position: -26px -131px;
    width: 13px;
    height: 8px;
    right: 14px;
    top: 50%;
    transform: translateY(-50%) rotate(-90deg);
}

@media (max-width: 1199px) {

    .qtime-subheader-nav.open-qtime-nav {
        background-color: #a3c6ec;
        border-radius: 0;
        border: 0;
    }

    .qtime-subheader-nav.open-qtime-nav li a {
        font-size: 13px;
        padding-top: 2px;
        color: #002b4b;
    }
	.dropdown-content {
        display: block;
        left: 0;
        top: 100%;
        width: 100%;
        border-radius: 0;
        border: 0;
        background-color: #b2cae5;
    }

    .qtime-subheader-nav.open-qtime-nav .dropdown-content a {
        font-size: 12px;
    }

    .qtime-subheader-nav .dropdown:after {
        transform: translateY(-50%) rotate(0deg);
    }
}
a.log-out-url {
    color: white;
}
</style>
